"use client";
import { T, useTextLocale, tl } from "@/components/t";

import { useEffect } from "react";

export default function JobsError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error("[Jobs Error]", error.message, error.stack);
  }, [error]);

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 p-6">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-amber-50">
        <svg className="h-8 w-8 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
      <h2 className="text-lg font-bold text-foreground"><T de={"Jobsuche konnte nicht geladen werden"} en={"Job search could not be loaded"} /></h2>
      <p className="text-sm text-muted-foreground text-center max-w-md">
        <T de={"Bitte versuche es erneut. Falls das Problem weiterhin besteht, lade die Seite neu."} en={"Please try again. If the problem persists, reload the page."} />
      </p>
      <button onClick={reset} className="rounded-xl bg-primary px-5 py-2.5 text-sm font-semibold text-white hover:bg-primary/90">
        <T de="Erneut versuchen" en="Try again" />
      </button>
    </div>
  );
}
